module.exports = __webpack_public_path__ + "img/customer_ux.45e4c730.png";